import React from 'react';
import { Button, Modal } from 'flowbite-react';
import { IoWarning } from 'react-icons/io5';
import { Img } from 'react-image';
const BrowserWarningModal = ({
	openModal,
	setOpenModal,
	isJoinedFromMobile,
}: {
	openModal: boolean;
	setOpenModal: (e: boolean) => void;
	isJoinedFromMobile: boolean;
}) => {
	return (
		<Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
			<Modal.Header className="pb-0" />
			<Modal.Body>
				<div className="text-center">
					{/* <IoWarning className="mx-auto mb-3 h-24 w-24 text-gray-400 dark:text-gray-200" /> */}
					<Img src="/assets/chromeLogo.svg" className="mx-auto mb-3 h-24 w-24" />
					<div className="h-full w-full dark:text-white flex flex-col gap-2 justify-center items-center">
						<p className=" text-2xl font-bold">
							{isJoinedFromMobile ? 'Mobile Device Not Supported' : 'Browser Not Supported'}
						</p>
						<p className=" text-base">
							{isJoinedFromMobile
								? 'Mobile devices are not supported for this interview.'
								: 'Please install the latest Chrome Browser on laptop/desktop for the interview.'}{' '}
							{!isJoinedFromMobile && (
								<a
									className="text-[#7777E7] dark:text-blue-400 "
									href="https://www.google.com/intl/en_in/chrome/"
									target="_blank"
								>
									Use Chrome
								</a>
							)}
						</p>
					</div>
					<div className="flex justify-center gap-4 mt-5">
						<Button color="purplePlaced" onClick={() => setOpenModal(false)}>
							OK
						</Button>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default BrowserWarningModal;
